import Image from 'next/image';
import React, { FC } from 'react';
import { GameReview } from '@/utils/api/prismic/prismicClient';
import { useRouter } from 'next/router';

export default function ReviewCardBlock({onReviewSelected, game, isAutoScroll}: {onReviewSelected: Function, game: GameReview, isAutoScroll: boolean}) {
  const router = useRouter();

  const selectReview = (review: GameReview) => {
    onReviewSelected(review);

    router.push(
      {
        pathname: '/game-reviews',
        query: {
          slug: game.slug,
        },
      },
      `/game-reviews/${game.slug}`,
      {
        shallow: true,
      },
    );
  }

  return (
    <button
      onClick={() => {
        selectReview(game);

        const isTabletOrLarger = window.matchMedia('(min-width: 768px)').matches;

        if (isTabletOrLarger) {
          return;
        }

        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }}
      className='relative group flex flex-col gap-2 items-center'
      key={game.slug}>
      <div
        style={{textShadow: '0 0 10px #000'}}
        title={`Оценка: ${game.score.label}`}
        className='absolute right-2 top-2 z-10 hover:cursor-help'>{game.score.emoji}</div>
        <Image
          src={game.cover!.sizes!.preview.url}
          alt={game.cover!.alt}
          width={200}
          height={100}
          placeholder="blur"
          blurDataURL={game.cover!.placeholderDataUrl!}
          className='w-full rounded-xl group-hover:brightness-150 transition-all duration-200 ease-in-out'/>
      <p className='text-sm line-clamp-1'>{game.title}</p>
    </button>
  )
}
